import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/components/PageWithFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/destinations/[slug]/DestinationFrameBack.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/travogue/travogue/src/styles/components/bookLoader.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/travogue/travogue/src/app/destinations/[slug]/destination.module.scss");
